import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import successPicture from "@/assets/images/audio-success.png";
import failedPicture from "@/assets/images/audio-failed.png";
import "@/assets/audioAddMusic.less";

const AudioWorkFinishRender = ({ status, audioJoinerAfter, handleDownload, handleSubmitAgain }) => {
  const { t } = useTranslation(["audioAddMusic","common"]);
  return (
    <div className="work-finish">
      <h2>{status === "failed" ? t("common:Export Failed") : t("common:Your audio is ready!")}</h2>
      <img src={status === "failed" ? failedPicture : successPicture} alt="finish" />
      {status === "success" ? (
        <div className="audio-info">
          <h3>{audioJoinerAfter.name}</h3>
          <div>
            <span>{(audioJoinerAfter.size / 1024 / 1024).toFixed(2)}MB</span>
            <span>{audioJoinerAfter.duration}</span>
          </div>
        </div>
      ) : null}
      <div className="btn-groups">
        <Button
          type="primary"
          ghost
          onClick={() => {
            window.open(window.location.href);
          }}
        >
          {t('Add New')}
        </Button>
        {status === "failed" ? (
          <Button onClick={handleSubmitAgain} type="primary">
            {t("common:Try Again")}
          </Button>
        ) : (
          <Button onClick={handleDownload} type="primary">
            {t("common:Download Audio")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default AudioWorkFinishRender;
